import MuiTextField, { TextFieldProps } from "@mui/material/TextField";

const TextField: React.FC<TextFieldProps> = MuiTextField;

export default TextField;
export type { TextFieldProps };
